<div class="modal-header">
  <h5 class="modal-title d-flex align-items-center gap-1">
    <i class="fal fa-money-check"></i>
    <ng-container i18n>Update this booking</ng-container>
    <app-page-help articleId="fx4k5LQXDf8rmyuwCTQer8"></app-page-help>
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <app-rental-select
      [multiple]="false"
      [ctrl]="form.get('rentalId')"
      [rentals$]="rentals$"
      placeholder="Airbnb Listings"
      i18n-placeholder
      label="Change Listing"
      i18n-label
      (selectedItemsChange)="onRentalChange($event)"
    ></app-rental-select>

    <div class="row">
      <div class="col-sm-6">
        <mat-form-field2 class="mat-block">
          <mat-select formControlName="adults" i18n-placeholder placeholder="Adults">
            <mat-option *ngFor="let option of adultsOptions" [value]="option">{{ option }}</mat-option>
          </mat-select>
        </mat-form-field2>
      </div>

      <div class="col-sm-6">
        <mat-form-field2 class="mat-block">
          <mat-select formControlName="children" i18n-placeholder placeholder="Children">
            <mat-option *ngFor="let option of childrenOptions" [value]="option">{{ option }}</mat-option>
          </mat-select>
        </mat-form-field2>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <mat-form-field2 class="mat-block">
          <mat-select formControlName="infants" i18n-placeholder placeholder="Infants">
            <mat-option *ngFor="let option of [0, 1, 2, 3, 4, 5]" [value]="option">{{ option }}</mat-option>
          </mat-select>
        </mat-form-field2>
      </div>

      <div class="col-sm-6">
        <mat-form-field2 class="mat-block">
          <mat-select formControlName="pets" i18n-placeholder placeholder="Pets">
            <mat-option *ngFor="let option of [0, 1, 2, 3, 4, 5]" [value]="option">{{ option }}</mat-option>
          </mat-select>
        </mat-form-field2>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <mat-form-field2 class="mat-block">
          <input
            matInput
            i18n-placeholder
            placeholder="Arrive"
            [matDatepicker]="guestArrivePicker"
            [required]="true"
            [min]="minDateDefault"
            [max]="maxArriveDate.value || maxDateDefault"
            (focus)="guestArrivePicker.open()"
            formControlName="guestArrive"
            readonly
          />
          <i matSuffix (click)="guestArrivePicker.open()" class="cs-icon cs-icon-calendar"></i>
          <mat-datepicker #guestArrivePicker></mat-datepicker>
        </mat-form-field2>
      </div>
      <div class="col-sm-6">
        <mat-form-field2 class="mat-block">
          <input
            matInput
            placeholder="Depart"
            i18n-placeholder
            [matDatepicker]="guestDepartPicker"
            [min]="minDepartDate.value || minDateDefault"
            [max]="maxDateDefault"
            [required]="true"
            (focus)="guestDepartPicker.open()"
            formControlName="guestDepart"
            readonly
          />
          <i matSuffix (click)="guestDepartPicker.open()" class="cs-icon cs-icon-calendar"></i>
          <mat-datepicker #guestDepartPicker></mat-datepicker>
          <mat-hint align="end">
            {{ inquiry.guestDepart | dateDiff : inquiry.guestArrive }} <ng-container i18n>Days</ng-container>,
            {{ inquiry.guestDepart | dateDiff : inquiry.guestArrive : 'nights' }}
            <ng-container i18n>Nights</ng-container>
          </mat-hint>
          <mat-error *ngIf="form.get('guestDepart').hasError('matDatepickerMin')">
            <ng-container i18n>Min value is</ng-container>&nbsp;
            <strong>{{ form.get('guestDepart').getError('matDatepickerMin').min | epoch : 'DD-MMM-YYYY' }}</strong>
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-sm-6">
        <mat-form-field2 class="mat-block">
          <input matInput type="number" formControlName="totalPrice" placeholder="Total Price" />
          <mat-error *ngIf="form.get('totalPrice').hasError('positive')">
            <ng-container i18n>Total price must be greater than 0</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i>
    <ng-container i18n>Cancel</ng-container>
  </button>
  <button (click)="onSave(form)" [disabled]="isUpdatingBooking$ | async" type="button" class="btn btn-secondary-info">
    <i class="cs-icon cs-icon-save"></i> <ng-container i18n>Save</ng-container>
  </button>
</div>
